import * as React from "react";
import {Route} from "react-router-dom";
import RoadsList from "./RoadNetworkManager/Roads/RoadsList";
import RoadEdit from "./RoadNetworkManager/Roads/RoadEdit";
import Road from "./RoadNetworkManager/Roads/Road";
import RoadSegments from "./RoadNetworkManager/RoadSegments/RoadSegments";
import RoadSegmentEdit from "./RoadNetworkManager/RoadSegments/RoadSegmentEdit";
import LayersListWrapper from "../../containers/map/tools/LayersList/LayersListWrapper";
import GroupSelection from "./RoadNetworkManager/GroupSelection/GroupSelection";
import BreadcrumbedComponent from "../../components/BreadcrumbedComponent/BreadcrumbedComponent";
import RouteChecker from "./RoadNetworkManager/RoadRouteChecker/RouteChecker";
import MapRoadsFilter from "./RoadNetworkManager/MapFilters/MapRoadsFilter";
import LazyLoadingWrapper from "../../components/LazyLoadingWrapper/LazyLoadingWrapper";
import LayersTimeSelectors from "../../components/map/LayersTimeSelectors";
import NavigateWithSearch from "../../components/NavigateWithSearch/NavigateWithSearch";
import DistrictsList from "../ScenarioPresetsMode/Manager/DistrictsList";
import DistrictEdit from "../ScenarioPresetsMode/Manager/DistrictEdit";
import {RoadInfrastructureEntityName} from "../../api/types/types";
import {EntityServiceName} from "../../api/enums/enums";


const RoadNetworkEditor = React.lazy(() => import('./RoadNetworkEditorModePage'));

export const useRoadsRoutes = () => {
    return (
        <Route path="network" element={<LazyLoadingWrapper element={<RoadNetworkEditor/>}/>}>
            <Route index element={<NavigateWithSearch to="roads" replace/>}/>
            <Route
                element={<BreadcrumbedComponent/>}
                handle={{crumb: (data: any) => ({name: 'Roads', ...data})}}
            >
                <Route path="roads">
                    <Route index element={<RoadsList/>}/>
                    <Route path="new" element={<RoadEdit/>}/>
                    <Route
                        path=":roadId"
                        element={<Road/>}
                        loader={({params}) => params}
                        handle={{
                            crumb: ({roadId}) => ({
                                id: roadId,
                                entityName: RoadInfrastructureEntityName.Road,
                                testId: 'roadIdBreadcrumb'
                            })
                        }}
                    >
                        <Route index element={<RoadSegments/>}/>
                        <Route path="edit" element={<RoadEdit/>}/>
                        <Route path=":new" element={<RoadSegmentEdit/>}/>
                        <Route
                            path=":roadSegmentId/edit"
                            element={<RoadSegmentEdit/>}
                            loader={({params}) => params}
                            handle={{
                                crumb: ({roadSegmentId}) => ({
                                    id: roadSegmentId,
                                    entityName: RoadInfrastructureEntityName.RoadSegment,
                                })
                            }}
                        />
                    </Route>
                </Route>
            </Route>
            <Route
                path="districts"
                element={<BreadcrumbedComponent/>}
                handle={{crumb: (data: any) => ({name: 'Districts', ...data})}}
            >
                <Route index element={<DistrictsList/>}/>
                <Route
                    path="new"
                    element={<DistrictEdit/>}
                    loader={({params}) => params}
                    handle={{crumb: ({districtId}) => ({id: districtId})}}
                />
                <Route
                    path=":districtId/edit"
                    element={<DistrictEdit/>}
                    loader={({params}) => params}
                    handle={{crumb: ({districtId}) => ({id: districtId})}}
                />
            </Route>
            <Route
                path='layers'
                element={
                    <LayersListWrapper>
                        <LayersTimeSelectors/>
                    </LayersListWrapper>
                }
            />
            <Route path='groupselection'
                   element={
                       <GroupSelection
                           entityName={'replancity_RoadInfrastructureUpdateSegment'}
                           sourceEntityName={RoadInfrastructureEntityName.RoadSegment}
                           groupUpdateTaskArgument="roadInfrastructureUpdateTask"
                       />
                   }/>
            <Route path='checkroute' element={<RouteChecker entityServiceName={EntityServiceName.ROAD_INFRASTRUCTURE}/>}/>
            <Route path='mapfilters' element={<MapRoadsFilter/>}/>
            {/*<Route*/}
            {/*    path="toll-pairs"*/}
            {/*    element={<BreadcrumbedComponent/>}*/}
            {/*    handle={{crumb: (data: any) => ({name: 'Toll pairs', ...data})}}*/}
            {/*>*/}
            {/*    <Route index element={<TollPairsList/>}/>*/}
            {/*    <Route*/}
            {/*        path=":tollPairId"*/}
            {/*        element={<TollPairEdit/>}*/}
            {/*        loader={({params}) => params}*/}
            {/*        handle={{crumb: ({tollPairId}) => ({id: tollPairId})}}*/}
            {/*    />*/}
            {/*</Route>*/}
            {/*<Route*/}
            {/*    path="toll-zones"*/}
            {/*    element={<BreadcrumbedComponent/>}*/}
            {/*    handle={{crumb: (data: any) => ({name: 'Toll zones', ...data})}}*/}
            {/*>*/}
            {/*    <Route index element={<TollZonesList/>}/>*/}
            {/*    <Route*/}
            {/*        path=":tollZoneId"*/}
            {/*        element={<TollZoneEdit/>}*/}
            {/*        loader={({params}) => params}*/}
            {/*        handle={{crumb: ({tollZoneId}) => ({id: tollZoneId})}}*/}
            {/*    />*/}
            {/*</Route>*/}
        </Route>
    )
}